// src/stone/icons/CheckRound.tsx
import { jsx } from "react/jsx-runtime";
var CheckRound = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M2 12.25C2 6.589 6.589 2 12.25 2S22.5 6.589 22.5 12.25 17.91 22.5 12.25 22.5 2 17.91 2 12.25m14.66-.998a1 1 0 1 0-1.32-1.504l-3.875 3.4-1.779-1.678a1 1 0 0 0-1.372 1.455l2.44 2.302a1 1 0 0 0 1.346.025z",
        clipRule: "evenodd"
      }
    )
  }
);
var CheckRound_default = CheckRound;

export {
  CheckRound,
  CheckRound_default
};
